import React from 'react'
import "./Our.css";

const our = () => {
  return (
    <div>
      <div class="grand_parent">
			<h2></h2>
			<div class="parents">
				<div class="child">
          <br></br>
        <h3>Our Vision</h3>
        <hr className='hr'/>
        <p>At Somnath Polytex, we envision a future where sustainable packaging solutions lead the way. </p>
        <br></br>
        <br></br>
				<h3>Our Mission</h3>
        <hr  className='hr'/>
        <p>We aim to do this while minimizing our environmental footprint and contributing to the well-being of the communities we serve.</p>

				
        </div>
        <div className="image-section4">
              <img src="/images/11.jpg" alt="" />
              </div>
				<div class="child">
        <br></br>
        <h3>Our Values</h3>
        <hr className='hr'/>
        <p>We expand along with our customers. Sincerity, trust, openness, responsibility, and a constructive outlook on business are things we cherish. </p>
				
				</div>
			</div>
		</div>
    </div>
  )
}

export default our
